export const QUEUE_INIT = 'QUEUE_INIT';
export const QUEUE_PLAYER_ADD = 'QUEUE_PLAYER_ADD';
export const QUEUE_PLAYER_REMOVE = 'QUEUE_PLAYER_REMOVE';
